import * as React from 'react';
import type { Token } from './Tokens';
import Tokens from './Tokens';
import cn from '~modules/cn';

import ChevronDownIcon from '../../../assets/icons/v2design/navigation/chevron-down.svg';
import './token-input.scss';

type Props = {
    values: Token[];
    disabled?: boolean;
    className?: string;
    placeholder?: string;
    onRemove?: (index: number) => void;
    onClick?: () => void;
    grow?: boolean;
};

const TokenInput = React.forwardRef<HTMLDivElement, Props>((props, ref) => (
    <div ref={ref} className={cn('token-input', props.className)} onClick={props.onClick}>
        <div className="token-input__tokens">
            {props.values.length > 0 && <Tokens values={props.values} disabled={props.disabled} onRemove={props.onRemove} />}
            {!props.values.length && <span className="token-input__placeholder">{props.placeholder}</span>}
        </div>
        <ChevronDownIcon />
    </div>
));

TokenInput.displayName = 'TokenInput';

export default TokenInput;
